import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../lib/api";

export function useRunScan(projectId) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (serverId) => (await apiClient.post(`/projects/${projectId}/servers/${serverId}/scan`)).data,
    onSettled: (_data, _err, serverId) => {
      queryClient.invalidateQueries({ queryKey: ["servers", projectId] });
      queryClient.invalidateQueries({ queryKey: ["scan", projectId, serverId] });
    },
  });
}

export function useScanDetail(projectId, serverId, enabled) {
  return useQuery({
    queryKey: ["scan", projectId, serverId],
    queryFn: async () => (await apiClient.get(`/projects/${projectId}/servers/${serverId}/scan`)).data,
    enabled: !!projectId && !!serverId && !!enabled,
  });
}
